<template>
    <div class="filtrate-info">
      <filtrate :projectId="patient.projectId" :isEdit="false"></filtrate>
      <div class="btn-panel">
        <template v-if="patient.status==='1'">
          <a-button type="primary" v-has="'patient:register'" @click="patientPassHandle">通过筛选</a-button>
          <a-button type="primary" v-has="'patient:register'" style="margin-left: 20px" @click="patientFailHandle">终止筛选</a-button>
        </template>
        <template v-else-if="patient.status==='3'">
          <a-button type="primary" @click="patientResetHandle">恢复筛选</a-button>
        </template>
      </div>
      <div class="filtrate-fail" v-if="patient.status==='3' && failList.length>0">
        <div class="fail-title">
          <a-icon type="info-circle" style="color: red"/>该病例目前【终止筛选】
        </div>
        <div class="fail-info">
          终止日期：{{failList[0].createTime}}
        </div>
        <div class="fail-info">
          终止操作人：{{failList[0].opName}}
        </div>
        <div class="fail-info">
          终止节点：{{failList[0].periodType ==='1'?'基线':'随访周期'}}
        </div>
        <div class="fail-info">
          终止原因：
        </div>
        <div v-for="(item,index) in failList" :key="index">
          <template v-if="item.type==='1'">
            <div class="fail-info" style="margin-left: 34px">
              不符合纳入条件
            </div>
            <div class="fail-info" style="margin-left: 50px" v-for="(info,ii) in item.info.split(',')" :key="ii">
              {{getDescription(info)}}
            </div>
            <div class="fail-info" style="margin-left: 50px">
              备注：{{item.remark}}
            </div>
         
          </template>
          <template v-if="item.type==='2'">
            <div class="fail-info" style="margin-left: 34px">
              符合排除标准
            </div>
            <div class="fail-info" style="margin-left: 50px" v-for="(info,ii) in item.info.split(',')" :key="ii">
              {{getDescription(info)}}
            </div>
            <div class="fail-info" style="margin-left: 50px">
              备注：{{item.remark}}
            </div>
          </template>
          <template v-if="item.type==='3'">
            <div class="fail-info" style="margin-left: 34px">
              受试者拒绝参加项目
            </div>
          </template>
          <template v-if="item.type==='4'">
            <div class="fail-info" style="margin-left: 34px">
              其他原因
            </div>
            <div class="fail-info" style="margin-left: 50px" >
              {{item.info}}
            </div>
          </template>
        </div>
      </div>

      <a-modal
        title="通过筛选"
        :width="600"
        :visible="passVisible"
        :confirmLoading="loading"
        @ok="handlePassSubmit"
        @cancel="passVisible = false">
        <a-form-model layout="horizontal" :model="passModel" v-bind="{labelCol: { span: 8 },wrapperCol: { span: 16 },}" ref="passForm" :rules="passRules">

          <!-- <a-form-model-item
            prop="groupId"
            label="组别"
            help="选择组别后不可更改"
          >
            <a-radio-group v-model="passModel.groupId">
              <a-radio v-for="(item, key) in groupList" :key="key" :value="item.id">{{ item.name }}</a-radio>
            </a-radio-group>
          </a-form-model-item>-->
          <a-form-model-item
            prop="create"
            label="自动生成随访">
            <a-switch  checkedChildren="是" unCheckedChildren="否" v-model="passModel.create" />
          </a-form-model-item> 
          <a-form-model-item
            v-if="passModel.create"
            prop="baseDate"
            :label="(period.baseName || '基点') + '日期'">
            <a-date-picker value-format='YYYY-MM-DD' v-model="passModel.baseDate" />
          </a-form-model-item>
          <!-- <a-form-model-item label="上传纸质版患者知情同意书">
            <a-switch v-model="passModel.processBl"/>
          </a-form-model-item>
          <a-form-model-item label="文件" v-if="passModel.processBl" >
            <j-image-upload class="avatar-uploader" :is-multiple="true" text="上传" v-model="passModel.processFile" :bizPath="`${patient.projectId}/patient/process`" @remove="remove"></j-image-upload>
            <ul class="file-list">
              <li v-for="item in (passModel.processFile ? passModel.processFile.split(','):[])">
                <img :src='baseUrl + item + "?token=" + token' alt="" width="100%" height="100%">
              </li>
              <li class="upload-item">
                <input type="file" @change="change" accept="image/*" capture="camera"/>
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  上传
                </div>
              </li>
            </ul> 
          </a-form-model-item> -->
          <!-- <a-form-model-item label="test upload">
            <div>
              <label>user</label>
              <input type="file" @change="change" capture="user">
            </div>

            <div>
              <label>environment</label>
              <input type="file" @change="change" capture="environment">
            </div>

            <div>
              <label>camera</label>
              <input type="file" @change="change" capture="camera">
            </div>

            <div>
              <label>filesystem</label>
              <input type="file" @change="change" capture="filesystem">
            </div>
            <div>
              <label>camcorder</label>
              <input type="file" @change="change" capture="camcorder">
            </div>
          </a-form-model-item> -->
        </a-form-model>
      </a-modal>
      <fail-filtrate :patient="patient" @opHandle="opHandle" ref="failFiltrate"></fail-filtrate>
    </div>
</template>

<script>
  import baseRules from '@/constants/baseRules'
  // import Filtrate from '@/views/project/components/Filtrate'
  import Filtrate from './Filtrate'
  import { getAction,postAction } from '@/api/manage'
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import FailFiltrate from './FailFiltrate'
  import moment from 'moment'
  import Vue from 'vue'
  import { ACCESS_TOKEN, TENANT_ID } from "@/store/mutation-types"
  export default {
    name: 'FiltrateInfo',
    components: { FailFiltrate, JImageUpload,  Filtrate },
    props:{
      patient:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    data(){
      return {
        baseUrl:window._CONFIG["domianURL"] + 'sys/common/static/',
        loading:false,
        passVisible:false,

        passModel:{
          typeList:[],
          type1Info:[],
          type2Info:[],
        },
        failList:[],
        dataSource:[],

        passRules:{
          groupId:[baseRules.requiredChange],
          baseDate:[baseRules.requiredChange],
        },
        period:{},
        groupList:[],
        token: Vue.ls.get(ACCESS_TOKEN)
      }
    },
    watch:{
      patient(){
        this.loadData()
      }
    },
    computed:{
      dataSource1(){
        return this.dataSource.filter(item=> item.type==='1')
      },
      dataSource2(){
        return this.dataSource.filter(item=> item.type==='2')
      },

    },
    mounted(){
      getAction('/project/projectGroup/list',{projectId:this.patient.projectId}).then(res=>{
        if(res.success){
          this.groupList = res.result
          this.passModel.groupId=this.groupList[0].id
        }
      })
      this.loadData()
    },
    methods:{
      async change(ev){
        const formData = new FormData();
        formData.append('file',ev.target.files[0])
        formData.append('biz',`${this.patient.projectId}/patient/process/${new Date().getTime()}`) 
        const res = await postAction(window._CONFIG['domianURL']+"sys/common/upload",formData)
        this.passModel.processFile = this.passModel.processFile ? `${this.passModel.processFile},${res.message}`:res.message
        ev.target.value = ''
      },
      remove(obj){
        const deleteFileName =  obj.response.message;
        this.passModel.processFile = this.passModel.processFile.split(',').filter(item => item !== deleteFileName).join(',');
      },
      loadData(){

        this.loading = true
        getAction('/project/projectFiltrate/list',{projectId:this.patient.projectId}).then(res=>{
          if(res.success){
            this.dataSource = res.result
          }
        }).finally(()=>{
          this.loading = false
        })
        getAction('/patient/patientFailInfo/list',{patientId:this.patient.id}).then(res=>{
          if(res.success){
            this.failList = res.result
          }
        })
      },
      getDescription(id){
        const results = this.dataSource.filter(item=>item.id===id)
        if(results.length>0){
          return results[0].sortNum +'、'+results[0].description
        }
        return ''
      },
      patientPassHandle(){
        if(!this.period.id){
          getAction('/project/projectPeriod/getPeriod',{projectId:this.patient.projectId}).then(res=>{
            if(res.success){
              this.period = res.result[0]
            }
          })
        }
        this.passModel = {
          id:this.patient.id,
          processBl:this.patient.process==='1',
          processFile:this.patient.processFile,
          baseDate: moment().format('YYYY-MM-DD'),
          create: true,
          groupId:this.groupList[0].id,
        }
        this.passVisible = true
      },
      opHandle(){
        this.$emit('opHandle')
      },
      handlePassSubmit(){
        this.$refs.passForm.validate(valid  => {
          if(valid){
            if(!this.passModel.create){
              this.passModel.baseDate = ''
            }
            this.passModel.process = this.passModel.processBl?'1':'0'
            this.loading = true
            postAction('/patient/patient/passFiltrate',this.passModel).then(res=>{
              if(res.success){
                this.passVisible = false
                this.$emit('opHandle')
              }
            }).finally(()=>{
              this.loading = false
            })
          }
        })
      },
      patientFailHandle(){
        this.$refs['failFiltrate'].view()
      },
      patientResetHandle(){
        this.$confirm({
          title: '恢复筛选',
          content: '是否确认恢复筛选？如果确认恢复，那么将不保存现在当前的筛选终止记录。',
          onOk:()=> {
            postAction('/patient/patient/resetFiltrate',{id:this.patient.id}).then(res=>{
              if(res.success){
                this.$emit('opHandle')
              }
            })
          },
        });
      },
    },

  }
</script>

<style scoped lang="less">
  .filtrate-info{

    .title{
      font-weight: bold;
      font-size: 16px;
    }
    .info-panel{
      padding: 10px;
      max-height: 260px;
      overflow-y: auto;
      .info-title{
        font-size: 16px;
      }
      .info-item{
        border-bottom: 1px solid rgba(0,0,0,0.1);
        line-height: 28px;
        padding-left: 20px;
      }
    }
    .btn-panel{
      margin-top: 5px;
      text-align: right;
    }
    .filtrate-fail{
      border: 0.5px solid rgba(221,51,55,0.5);
      margin-top: 10px;
      padding: 10px;
      background-color: #FFF1F0;
      .fail-title{
        font-size: 16px;
      }
      .fail-info{
        margin-left: 20px;
      }
    }
  }

  .file-list{
    list-style: none;
    padding: 0;
    display: flex;
    column-gap: 10px;
    li{
      width: 104px;
      height: 104px;
      padding: 8px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
    }
    .upload-item{
      font-size: 18px;
      text-align: center;
      position: relative;
      border: 1px dashed #d9d9d9;
      input{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }
</style>